import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MdOutlineWatchLater } from "react-icons/md";
import Sidebar from "../Components/Sidebar";
import axios from "axios"; // ✅ ADDED: API call ke liye
import Constant from "../Components/Utils/Constant"; // ✅ ADDED: Base URL ke liye
import { useDispatch, useSelector } from "react-redux";
import FeedbackReview from "./FeedbackReview";
import {
  affiliateRequest,
  modelsRequest,
  userRequest,
} from "../Redux/reducer/DataReducer";

const Dashboard = ({ columns, data }) => {
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  // ✅ ADDED: Naye counts ko store karne ke liye state
  const [dashboardCounts, setDashboardCounts] = useState(null);

  const userRes = useSelector((state) => state?.DataReducer?.user);
  const affiliateRes = useSelector((state) => state?.DataReducer?.affiliate);
  const modelsRes = useSelector((state) => state?.DataReducer?.models);
  const dispatch = useDispatch();

  const navigate = useNavigate();

  // top performing affiliates filter (No changes)
  const handleMonthChange = (e) => {
    setSelectedMonth(e.target.value);
  };

  const handleYearChange = (e) => {
    setSelectedYear(e.target.value);
  };

  const filteredAffiliates =
    affiliateRes?.affiliate
      ?.filter((affiliate) => {
        const createdAt = new Date(affiliate.createdAt);
        const isSameMonth = selectedMonth
          ? createdAt.getMonth() + 1 === parseInt(selectedMonth)
          : true;
        const isSameYear = selectedYear
          ? createdAt.getFullYear() === parseInt(selectedYear)
          : true;
        return isSameMonth && isSameYear;
      })
      .map((affiliate) => {
        const salesCount = userRes?.admins?.filter(
          (user) =>
            user.createdby === affiliate.name && user.usertype === "Sales"
        ).length;
        return { ...affiliate, salesCount };
      })
      .sort((a, b) => b.salesCount - a.salesCount) || [];

  useEffect(() => {
    // Yeh Redux actions tables ke liye zaroori hain, isliye inko rakha gaya hai
    dispatch(userRequest());
    dispatch(affiliateRequest());
    dispatch(modelsRequest());

    // ✅ ADDED: Nayi API se sirf counts fetch karne ka function
    const fetchDashboardCounts = async () => {
      try {
        // API call to your localhost
        const response = await axios.get(`${Constant.BASE_URL}/user/counts`);
        if (response.data.success) {
          setDashboardCounts(response.data.counts);
        }
      } catch (error) {
        console.error("Failed to fetch dashboard counts:", error);
      }
    };

    fetchDashboardCounts();
  }, [dispatch]);


  // Unchanged variables for existing cards and tables
  const formattedTime = `${
    userRes?.updatedAt && userRes?.updatedAt.split("T")[1].split(".")[0]
  }`;
  const formattedDate = `${
    userRes?.updatedAt && userRes?.updatedAt?.split("T")[0]
  }`;
  const formattedTime1 = `${
    userRes?.createdAt && userRes?.createdAt.split("T")[1].split(".")[0]
  }`;
  const formattedDate1 = `${
    userRes?.createdAt && userRes?.createdAt?.split("T")[0]
  }`;
  const hittime1 = `${
    userRes?.hittime && userRes?.hittime.split("T")[1].split(".")[0]
  }`;
  const hitdate1 = `${userRes?.hittime && userRes?.hittime?.split("T")[0]}`;
  const modelcreatedAt = `${modelsRes && modelsRes?.createdAt?.split("T")[0]}`;
  const modelcreatedAt1 = `${
    modelsRes && modelsRes?.createdAt?.split("T")[1].split(".")[0]
  }`;


  // ✅ MODIFIED: cardData ab naye state `dashboardCounts` se data lega.
  // Revenue cards ko chheda nahi gaya hai.
  const cardData = [
    {
      category: "total",
      gradientColors: ["rgba(148, 239, 140, 0.85) ", " rgba(20, 139, 0, 0.85)"],
      amount: 15000,
      title: "Total Revenue",
      updatetext: "Update :",
      updateTime: { date: formattedDate, time: formattedTime },
    },
    {
      category: "app",
      gradientColors: ["rgba(254, 208, 88, 0.85)", "rgba(255, 138, 0, 0.85)"],
      amount: 15000,
      title: "App Revenue",
      updatetext: "Update :",
      updateTime: { date: formattedDate, time: formattedTime },
    },
    {
      category: "affiliate",
      gradientColors: ["rgba(26, 208, 218, 0.85)", "rgba(40, 111, 249, 0.85)"],
      amount: 15000,
      title: "Affiliate Revenue",
      updatetext: "Update :",
      updateTime: { date: formattedDate, time: formattedTime },
    },
    {
      category: "models",
      gradientColors: ["rgba(253, 133, 144, 0.85)", "rgba(253, 54, 52, 0.85)"],
      amount: dashboardCounts?.totalModels ?? "...",
      title: "Models",
      updatetext: "Update :",
      updateTime: { date: modelcreatedAt, time: modelcreatedAt1 },
    },
    {
      category: "activeUsers",
      gradientColors: [" rgba(140, 144, 239, 0.85)", "rgba(78, 0, 139, 0.85)"],
      amount: dashboardCounts?.activeUsers ?? "...",
      title: "Active Users",
      updatetext: "Update :",
      updateTime: { date: hitdate1, time: hittime1 },
    },
    {
      category: "inactiveUsers",
      gradientColors: ["rgba(254, 88, 128, 0.85)", "rgba(255, 0, 61, 0.85)"],
      amount: dashboardCounts?.inactiveUsers ?? "...",
      title: "Inactive Users",
      subtitle: "(Need Clearance)",
      updatetext: "Update :",
      updateTime: { date: hitdate1, time: hittime1 },
    },
    {
      category: "expiredUsers",
      gradientColors: ["rgba(180, 218, 26, 0.85)", "rgba(249, 90, 40, 0.85)"],
      amount: dashboardCounts?.expiredUsers ?? "...",
      title: "Expired Users",
      updatetext: "Update :",
      updateTime: { date: hitdate1, time: hittime1 },
    },
    {
      category: "totalUsers",
      gradientColors: ["rgba(254, 128, 88, 0.85)", "rgba(0, 87, 255, 0.85)"],
      amount: dashboardCounts?.totalUsers ?? "...",
      title: "Total Users",
      updatetext: "Update :",
      updateTime: { date: formattedDate1, time: formattedTime1 },
    },
  ];

  // (The rest of your component code remains exactly the same)
  const getBorderColor = (category) => {
    switch (category) {
      case "total":
        return "rgb(240, 240, 240)";
      case "app":
        return "rgba(254, 208, 88, 0.85)";
      case "affiliate":
        return "rgba(26, 208, 218, 0.85)";
      case "models":
        return "rgba(253, 133, 144, 0.85)";
      case "activeUsers":
        return "rgba(140, 144, 239, 0.85)";
      case "inactiveUsers":
        return "rgba(254, 88, 128, 0.85)";
      case "expiredUsers":
        return "rgb(249 90 40 / 17%)";
      case "totalUsers":
        return "rgb(139 162 206 / 58%)";
      default:
        return "rgba(0, 0, 0, 0.25)";
    }
  };
  return (
    <Sidebar>
      <>
        <div className="flex  items-center h-scrren ">
          <div className="flex flex-col bg-gray-300 items-center overflow-y-auto h-[78vh] main3table">
            <div className="cardscar w-100 flex justify-center items-center flex-wrap lg:gap-4 xl:gap-10 2xl:gap-14 px-3 py-3 lg:px-0 lg:py-2 xl:px-3 xl:py-3">
              {cardData.map((card, index) => (
                <div
                  key={index}
                  className={`w-[22%] lg:w-[23%] xl:w-[22%] 2xl:w-[23%] rounded-md overflow-hidden transition-all duration-200`}
                  style={{
                    boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
                    border: `1px solid ${getBorderColor(card.category)}`,
                  }}
                >
                  <div
                    style={{
                      background: `radial-gradient(circle at right top, ${card.gradientColors[0]} 0%, ${card.gradientColors[1]} 100%)`,
                    }}
                    className="flex flex-col text-white"
                  >
                    <div className="flex justify-end px-5 pt-5 2xl:py-5">
                      <h3 className="flex items-center text-[25px] lg:text-[20px] xl:text-[25px] 2xl:text-[40px]">
                        <span>{card.amount}</span>{" "}
                      </h3>
                    </div>
                    <div className=" text-[22px]  lg:text-[16px] xl:text-[25px] 2xl:text-[35px] px-5 pb-2 pt-0">
                      <p>
                        {" "}
                        {card.title}
                        <span className="text-[10px] lg:text-[7px] xl:text-[9px] 2xl:text-[14px]">
                          {card.subtitle}
                        </span>
                      </p>
                    </div>
                    <div className="hrline-card border border-t bg-white"></div>
                    <div className="flex px-5 py-2 lg:px-2 xl:px-5 text-[12px] lg:text-[9px] xl:text-[11px]  2xl:text-[20px] 2xl:py-3">
                      <ul className="flex  items-center space-4xl lg:space-1xl xl:space-4xl">
                        <li>
                          <MdOutlineWatchLater className="text-1xl" />
                        </li>
                        <li>
                          <p className="pl-2 pr-5 lg:pr-0 xl:pr-5">
                            {card.updatetext}
                          </p>
                        </li>
                        <li className="">
                          <p>
                            {card.updateTime.date}, {card.updateTime.time}
                          </p>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="flex justify-around w-full py-5 px-5 lg:py-3 xl:py-3 2xl:py-10">
              <div className=" w-[28%] lg:w-[30%] xl:w-[28%] 2xl:w-[30%] h-[500px]  lg:h-[335px] xl:h-[500px] 2xl:h-[540px]  flex flex-col justify-between  items-center rounded-lg border-1 border-solid border-white border-opacity-60 bg-white bg-opacity-57 shadow-md backdrop-filter backdrop-blur-[5.7px]">
                <div className="w-full flex flex-col overflow-y-auto h-[450px] lg:h-[300px] xl:h-[450px] 2xl:h-[500px] dashboardtable1">
                  <p className="flex text-[14px] lg:text-[12px] xl:text-[14px] 2xl:text-[23px] 2xl:p-5 p-3  font-bold  ">
                    {" "}
                    Recent Users
                  </p>
                  <table className=" table-3admin " id="myTable">
                    <thead className="">
                      <tr>
                        <th>Name</th>
                        <th>Created By</th>
                        <th>Created On</th>
                      </tr>
                    </thead>
                    <tbody className="">
                      {userRes?.admins &&
                        userRes.admins
                          .slice()
                          .sort(
                            (a, b) =>
                              new Date(b.createdAt) - new Date(a.createdAt)
                          )
                          .slice(0, 10)
                          .map((row, index) => (
                            <tr key={index} className="">
                              <td>{row.name}</td>
                              <td>{row.createdby}</td>
                              <td>{row.createdAt.split("T")[0]}</td>
                            </tr>
                          ))}
                    </tbody>
                  </table>
                </div>

                <div className="w-full flex flex-col text-[13px] lg:text-[11px] xl:text-[14px] 2xl:text-[20px] text-black ">
                  <hr style={{ color: "#DDD" }} className="w-full  border  " />
                  <ul className="flex pl-4 lg:pl-4 xl:pl-4 2xl:pl-6  items-center space-x-4 lg:space-x-4 xl:space-x-4 2xl:space-x-10 py-2">
                    <li>
                      <MdOutlineWatchLater className="text-1xl" />
                    </li>
                    <li>
                      <p className=" pr-2">Update :</p>
                    </li>
                    <li className="">
                      <p>
                        {userRes?.createdAt &&
                          userRes?.createdAt?.split("T")[0]}{" "}
                        Time{" "}
                        {userRes?.createdAt &&
                          userRes?.createdAt.split("T")[1].split(".")[0]}
                      </p>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="w-[28%] lg:w-[30%] xl:w-[28%] 2xl:w-[30%] h-[500px] lg:h-[335px] xl:h-[500px] 2xl:h-[540px] flex flex-col justify-between items-center rounded-lg border-1 border-solid border-white border-opacity-60 bg-white bg-opacity-57 shadow-md backdrop-filter backdrop-blur-[5.7px]">
                <div className="w-full flex flex-col overflow-y-auto h-[450px] lg:h-[300px] xl:h-[450px] 2xl:h-[500px] dashboardtable1">
                  <div className="flex justify-between items-center p-2">
                    <p className="flex text-[14px] lg:text-[12px] xl:text-[14px] 2xl:text-[23px] 2xl:p-3 p-3 lg:p-0 xl:p-1 font-bold">
                      Top Performing Affiliates
                    </p>
                    <div className="flex items-center bg-white shadow-md border border-white text-black">
                      <select
                        id="monthSelect"
                        className="outline-none text-[9px] lg:text-[9px] xl:text-[9px] 2xl:text-[13px]"
                        value={selectedMonth}
                        onChange={handleMonthChange}
                        required
                      >
                        <option value="" disabled>
                          MM
                        </option>
                        {Array.from({ length: 12 }, (_, i) => (
                          <option key={i + 1} value={i + 1}>
                            {new Date(2022, i, 1).toLocaleString("en-US", {
                              month: "long",
                            })}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="flex items-center bg-white shadow-md border border-white text-black lg:pr-0 xl:pr-0 2xl:pr-5">
                      <select
                        id="yearSelect"
                        className="outline-none text-[9px] lg:text-[9px] xl:text-[9px] 2xl:text-[13px]"
                        value={selectedYear}
                        onChange={handleYearChange}
                        required
                      >
                        <option value="" disabled>
                          YYYY
                        </option>
                        {Array.from({ length: 90 }, (_, i) => (
                          <option key={2020 + i} value={2020 + i}>
                            {2020 + i}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <table className="table-3admin" id="myTable">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Created By</th>
                        <th>Sales</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredAffiliates.slice(0, 10).map((row, index) => (
                        <tr key={index}>
                          <td>{row.name}</td>
                          <td>{row.createdby}</td>
                          <td>
                            {" "}
                            {
                              userRes?.admins?.filter((user) => {
                                return (
                                  user?.createdby === row?.name &&
                                  user?.usertype === "Sales"
                                );
                              }).length
                            }
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                <div className="w-full flex flex-col text-[13px] lg:text-[11px] xl:text-[14px] 2xl:text-[20px] text-black">
                  <hr style={{ color: "#DDD" }} className="w-full border" />
                  <ul className="flex pl-4 items-center space-x-4 lg:space-x-4 xl:space-x-4 2xl:space-x-10 py-2">
                    <li>
                      <MdOutlineWatchLater className="text-1xl" />
                    </li>
                    <li>
                      <p className="pr-2">Update :</p>
                    </li>
                    <li>
                      <p>
                        {affiliateRes?.hitTime &&
                          affiliateRes?.hitTime?.split("T")[0]}{" "}
                        Time{" "}
                        {affiliateRes?.hitTime &&
                          affiliateRes?.hitTime.split("T")[1].split(".")[0]}
                      </p>
                    </li>
                  </ul>
                </div>
              </div>

              <FeedbackReview />
            </div>
          </div>
        </div>
      </>
    </Sidebar>
  );
};

export default Dashboard;

